import { format } from 'date-fns';

/**
 * Extrae año/mes/día del string ISO sin aplicar zona horaria del navegador.
 * Ej: "2026-06-19T00:00:00.000Z" → { year: 2026, month: 6, day: 19 }
 */
export function parseDateParts(dateString) {
  if (!dateString) {
    return null;
  }

  const [datePart] = String(dateString).split('T');
  const [year, month, day] = datePart.split('-').map(Number);

  if (!year || !month || !day) {
    return null;
  }

  return { year, month, day };
}

export function toUtcDateMs({ year, month, day }) {
  return Date.UTC(year, month - 1, day);
}

/** Días hasta el vencimiento (0 = vence hoy, negativo = vencido). */
export function getPaymentDaysDifference(paymentDateString) {
  const parts = parseDateParts(paymentDateString);
  if (!parts) {
    return null;
  }

  const paymentMs = toUtcDateMs(parts);
  const now = new Date();
  const todayMs = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());

  return Math.round((paymentMs - todayMs) / 86400000);
}

export function isPaymentDateExpired(paymentDateString) {
  const diff = getPaymentDaysDifference(paymentDateString);
  return diff !== null && diff < 0;
}

export function isClassAfterPaymentPeriod(paymentDateString, classDay) {
  const paymentParts = parseDateParts(paymentDateString);
  if (!paymentParts) {
    return false;
  }

  const classDate = classDay instanceof Date ? classDay : new Date(classDay);
  const classMs = Date.UTC(
    classDate.getFullYear(),
    classDate.getMonth(),
    classDate.getDate()
  );
  const paymentMs = toUtcDateMs(paymentParts);

  return classMs > paymentMs;
}

export function formatAbsoluteDateLabel(dateString, translate) {
  const parts = parseDateParts(dateString);
  if (!parts) {
    return '';
  }

  const fixedDate = new Date(parts.year, parts.month - 1, parts.day);
  const monthKey = format(fixedDate, 'MMMM');
  const monthLabel = translate ? translate(monthKey) : monthKey;

  return `${String(parts.day).padStart(2, '0')} ${monthLabel} ${parts.year}`;
}

/** Misma lógica que ScheduleCalendar.parseDateAbsolute */
export function parseDateAbsolute(dateString) {
  const parts = parseDateParts(dateString);
  if (!parts) {
    return null;
  }
  return new Date(parts.year, parts.month - 1, parts.day);
}
